import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import { useTheme } from 'Hooks';
import { store } from 'Utilities/store';
const Providers = ({ children }) => {
    const { theme } = useTheme();
    const isTestEnvironment = store.getState().env.isTestEnvironment;
    const defaultTheme = theme.endsWith('Dark') ? 'dark' : 'light';
    return (React.createElement(ParallaxProvider, { config: config, locale: "en-US", dir: "ltr", isTestEnvironment: Boolean(isTestEnvironment), defaultTheme: defaultTheme }, children));
};
export default Providers;
